import axios from "axios"
 



export const getForgetPassApi = (data) => {
	    const baseUrl = process.env.REACT_APP_BASE_URL_ONE;
	return axios
		.post(baseUrl+"api/v1/users/settings/request-password-reset/", data)
		.then( (res)=> {
			
			return res
		})
		.catch((err) => {
           
			return err
          
		})
}
